import script from "./VideoconferenceLinkSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoconferenceLinkSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./VideoconferenceLinkSwitch.vue?vue&type=style&index=0&id=b11e5d56&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b11e5d56"]])

export default __exports__